var _rect, _rect2, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _g5, _path5, _path6, _path7, _g6, _g7, _g8, _g9, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordPlayerHappyHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 910,
    height: 692,
    viewBox: "0 0 910 692",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 42,
    width: 910,
    height: 650,
    rx: 16,
    fill: "#182825"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 904,
    height: 644,
    rx: 13,
    fill: "#545F5D",
    stroke: "#182825",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M614.999 603.404C633.602 603.404 648.682 588.323 648.682 569.72C648.682 551.117 633.602 536.037 614.999 536.037C596.396 536.037 581.315 551.117 581.315 569.72C581.315 588.323 596.396 603.404 614.999 603.404Z",
    fill: "#FFE768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.171 562.774C590.961 561.631 590.979 560.457 591.223 559.32C591.467 558.184 591.933 557.106 592.593 556.15C593.254 555.193 594.097 554.376 595.073 553.745C596.049 553.114 597.14 552.682 598.284 552.472C600.594 552.05 602.977 552.563 604.909 553.898C606.841 555.232 608.163 557.28 608.586 559.589",
    fill: "#5DA7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.68 570.04C634.017 574.451 632.588 578.815 629.708 582.173C626.828 585.532 622.732 587.609 618.321 587.948C613.91 588.286 609.544 586.858 606.185 583.978C602.826 581.098 600.749 577.001 600.41 572.59",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.411 559.041C620.666 557.911 621.142 556.843 621.811 555.897C622.48 554.951 623.328 554.146 624.308 553.528C625.288 552.91 626.38 552.491 627.522 552.295C628.663 552.099 629.833 552.129 630.963 552.385C633.245 552.902 635.228 554.304 636.477 556.282C637.726 558.261 638.138 560.655 637.622 562.937",
    fill: "#5DA7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.137 557.373C644.522 549.226 640.1 541.565 633.023 536.527C627.295 532.453 620.182 530.625 613.192 531.064C599.3 531.934 585.897 540.937 580.492 553.872C574.721 567.689 579.266 584.933 591.109 594.082C598.571 599.845 608.132 601.822 617.404 601.198C625.406 600.658 633.201 597.796 638.689 591.767C645.425 584.368 648.309 573.395 647.895 563.518C647.895 563.307 647.895 563.1 647.866 562.89C647.779 561.62 646.016 560.942 645.327 562.205C642.342 567.722 639.215 573.275 635.323 578.216C633.059 581.085 630.469 583.849 627.234 585.619C620.233 589.442 610.145 588.086 604.222 582.924C600.957 580.076 598.476 575.981 598.117 571.596L596.757 572.956L627.879 570.312L632.406 569.927C634.137 569.778 634.151 567.058 632.406 567.207L601.284 569.851L596.757 570.235C596.071 570.297 595.331 570.816 595.397 571.596C596.224 581.647 604.958 589.007 614.621 590.193C618.528 590.675 622.787 590.436 626.479 588.963C630.052 587.541 633.008 585.031 635.548 582.18C640.463 576.641 644.177 570.054 647.685 563.576L645.146 562.89C645.668 570.42 643.905 578.727 640.114 585.235C636.741 591.068 631.231 595.361 624.749 597.205C616.286 599.65 606.224 599.102 598.244 595.282C585.204 589.047 578.294 573.71 581.46 559.709C584.362 546.926 595.723 537.219 608.263 534.473C614.429 533.117 621.049 533.505 626.846 536.102C633.669 539.167 638.693 544.909 641.932 551.547C642.948 553.659 643.81 555.841 644.511 558.077C645.044 559.734 647.674 559.027 647.137 557.351V557.373Z",
    fill: "#2C4A43"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_26_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553.285 583.292C570.02 591.416 590.172 584.434 598.296 567.698C606.419 550.963 599.437 530.811 582.702 522.688C565.966 514.564 545.814 521.546 537.691 538.281C529.568 555.017 536.549 575.169 553.285 583.292Z",
    fill: "#FFE768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.59 536.336C549.901 535.216 550.429 534.168 551.145 533.252C551.861 532.336 552.75 531.57 553.762 530.998C554.774 530.426 555.889 530.059 557.043 529.917C558.197 529.776 559.367 529.864 560.488 530.175C562.75 530.804 564.67 532.305 565.825 534.35C566.98 536.394 567.276 538.813 566.648 541.076",
    fill: "#5DA7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.659 561.434C583.036 565.55 579.846 568.852 575.788 570.616C571.731 572.379 567.139 572.459 563.023 570.838C558.906 569.216 555.603 566.025 553.839 561.967C552.074 557.91 551.994 553.317 553.616 549.2",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.525 545.746C578.249 544.841 579.143 544.088 580.158 543.529C581.173 542.97 582.288 542.616 583.439 542.488C584.59 542.36 585.756 542.459 586.869 542.782C587.981 543.104 589.02 543.642 589.925 544.366C591.752 545.827 592.924 547.954 593.184 550.28C593.443 552.605 592.769 554.938 591.308 556.766",
    fill: "#5DA7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.297 555.916C603.502 547.444 602.869 538.622 598.703 530.999C595.329 524.833 589.728 520.082 583.248 517.425C570.37 512.141 554.381 514.388 543.87 523.665C532.645 533.574 529.204 551.072 535.864 564.474C540.059 572.917 547.798 578.871 556.411 582.358C563.846 585.366 572.108 586.196 579.678 583.169C588.969 579.453 596.355 570.841 600.296 561.775C600.388 561.585 600.478 561.399 600.544 561.197C601.02 560.017 599.73 558.637 598.559 559.472C593.464 563.132 588.226 566.762 582.568 569.507C579.278 571.1 575.741 572.456 572.058 572.635C564.09 573.018 555.607 567.392 552.533 560.162C550.839 556.175 550.395 551.407 551.987 547.305L550.169 547.935L579.323 559.146L583.563 560.777C585.185 561.399 586.386 558.958 584.751 558.33L555.598 547.118L551.357 545.488C550.714 545.244 549.822 545.387 549.54 546.117C545.895 555.521 550.539 565.956 558.714 571.243C562.018 573.383 565.953 575.027 569.919 575.315C573.754 575.596 577.509 574.628 581.039 573.172C587.879 570.335 594.097 566.031 600.081 561.735L598.097 560.009C595.278 567.012 590.065 573.715 583.813 577.914C578.231 581.689 571.399 583.145 564.763 581.973C556.082 580.477 547.269 575.591 541.758 568.67C532.75 557.366 533.23 540.552 542.193 529.338C550.385 519.106 564.844 515.334 577.325 518.34C583.464 519.812 589.25 523.052 593.331 527.919C598.131 533.656 600.143 541.016 600.158 548.402C600.151 550.745 599.973 553.084 599.627 555.402C599.383 557.126 602.058 557.638 602.307 555.896L602.297 555.916Z",
    fill: "#2C4A43"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_26_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M851.149 258.267C854.607 267.774 856.152 277.871 855.696 287.98C855.24 298.089 852.792 308.013 848.492 317.186C844.192 326.358 838.124 334.599 830.634 341.438C823.144 348.277 814.38 353.58 804.841 357.044C795.3 360.508 785.172 362.066 775.034 361.627C764.896 361.188 754.948 358.762 745.757 354.486C736.567 350.211 728.314 344.17 721.47 336.71C714.625 329.249 709.324 320.514 705.869 311.004L851.149 258.267Z",
    fill: "#EE8868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.33 279.504C829.711 285.563 830.872 292.033 830.745 298.544C830.619 305.055 829.207 311.479 826.592 317.451C823.977 323.422 820.209 328.823 815.503 333.346C810.797 337.868 805.246 341.424 799.166 343.809C786.886 348.625 773.199 348.382 761.116 343.134C749.033 337.886 739.543 328.063 734.734 315.825L827.33 279.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.163 322.825C717.763 318.169 729.387 313.543 740.959 308.814C745.911 306.796 750.23 304.875 754.254 301.265C756.257 299.455 758.264 297.358 760.914 296.577C763.945 295.692 767.27 296.922 770.085 298.117C770.603 298.375 771.189 298.465 771.762 298.374C772.334 298.283 772.864 298.016 773.278 297.611C774.11 296.645 774.802 295.566 775.33 294.407C776.675 292.005 778.313 289.751 780.887 288.508C785.143 286.451 787.849 291.611 792.298 291.449C796.056 291.313 799.848 289.428 803.275 288.06C814.205 283.703 825.009 279.016 835.886 274.505C838.158 273.563 840.429 272.621 842.721 271.724C843.381 271.465 844.113 271.223 844.796 270.942C845.366 270.702 846.04 270.741 845.239 270.718L842.552 268.12C843.632 276.08 842.365 284.747 840.848 292.533C838.185 306.097 832.909 319.535 823.867 330.157C802.923 354.684 763.81 359.531 737.349 341.596C732.704 338.361 728.388 334.68 724.463 330.606C722.065 328.166 719.891 325.382 717.259 323.172L715.478 327.734C716.748 327.826 718.355 327.078 719.525 326.7C722.374 325.794 725.203 324.822 728.03 323.842C737.192 320.691 746.318 317.439 755.448 314.179C776.109 306.805 796.775 299.319 817.423 291.852L827.818 288.084C828.804 287.73 829.827 287.402 830.783 287.02C831.286 286.829 832.676 286.622 831.282 286.713L828.705 284.817C830.568 289.409 827.616 295.985 825.734 300.1C821.865 308.403 816.359 315.847 809.544 321.985C801.706 329.115 791.769 335.009 781.119 336.365C771.605 337.58 761.872 335.779 752.986 332.365C749.162 330.93 745.478 329.147 741.982 327.039C740.823 326.349 739.712 325.583 738.656 324.745C737.947 324.16 737.195 322.971 737.573 323.961C736.36 320.816 731.258 322.269 732.487 325.446C733.267 327.463 735.172 328.77 736.873 329.983C739.877 332.069 743.072 333.87 746.414 335.362C755.754 339.626 766.045 342.307 776.368 342.022C798.95 341.43 819.215 324.458 829.162 305.011C832.128 299.216 836.41 289.984 833.723 283.352C833.547 282.805 833.203 282.326 832.738 281.985C832.274 281.644 831.714 281.457 831.137 281.452C829.927 281.661 828.75 282.029 827.637 282.547C824.972 283.501 822.288 284.468 819.586 285.448L792.7 295.168C771.944 302.695 751.181 310.224 730.315 317.453C726.702 318.714 723.086 319.967 719.453 321.16C718.371 321.512 717.281 321.86 716.193 322.193C715.42 322.418 714.593 322.41 715.325 322.446C713.069 322.283 711.824 325.581 713.537 327.01C715.949 329.02 717.964 331.586 720.137 333.813C723.801 337.625 727.778 341.126 732.025 344.28C743.694 352.867 757.53 357.784 772.117 357.81C790.31 357.839 809.374 351.422 822.753 338.918C833.869 328.52 840.837 314.374 844.599 299.808C847.164 289.867 849.26 278.317 847.838 268.052C847.808 267.357 847.513 266.7 847.013 266.216C846.514 265.732 845.847 265.457 845.15 265.447C842.522 265.371 839.125 267.5 836.825 268.443C831.245 270.732 825.672 273.093 820.126 275.423C814.39 277.832 808.647 280.242 802.871 282.567C799.84 283.782 793.69 287.316 790.399 285.775C788.485 284.867 787.441 283.206 785.243 282.71C783.022 282.311 780.729 282.653 778.72 283.683C776.353 284.883 774.285 286.597 772.67 288.699C771.909 289.703 771.236 290.771 770.658 291.891C770.354 292.434 769.19 294.197 769.399 294.004L772.599 293.495C767.083 291.189 761.45 289.767 755.984 293.05C753.652 294.464 751.741 296.49 749.699 298.267C747.359 300.203 744.703 301.723 741.848 302.76C729.48 307.838 717.049 312.773 704.645 317.751C701.509 319.012 702.962 324.111 706.125 322.821L706.163 322.825Z",
    fill: "#2C4A43"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_26_1261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.8979,
    y: 157.932,
    width: 73.8682,
    height: 102.462,
    rx: 3.17713,
    transform: "rotate(-97.7005 42.8979 157.932)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9196 141.505C47.6635 135.782 47.5397 129.865 48.5554 124.094C49.5712 118.322 51.7065 112.809 54.8394 107.868C57.9724 102.927 62.0417 98.6553 66.8149 95.2972C71.5881 91.9391 76.9718 89.5601 82.6585 88.2961C88.345 87.0313 94.2232 86.9063 99.9577 87.9281C105.692 88.9499 111.17 91.0986 116.08 94.2515C120.989 97.4044 125.233 101.5 128.57 106.304C131.906 111.108 134.27 116.526 135.526 122.249L48.9196 141.505Z",
    fill: "#EE8868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0176 141.506C50.8826 131.78 52.6732 121.6 57.9955 113.204C63.3178 104.807 71.7359 98.8824 81.3983 96.7323C91.0609 94.5835 101.176 96.3856 109.518 101.742C117.861 107.099 123.748 115.572 125.884 125.296L53.0176 141.506Z",
    fill: "#FFE768"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0171 140.073C59.3803 132.615 60.7543 124.808 64.8369 118.369C68.9195 111.93 75.3764 107.387 82.787 105.739C90.1976 104.092 97.9549 105.475 104.352 109.584C110.75 113.693 115.264 120.192 116.901 127.65L61.0171 140.073Z",
    fill: "#6CE4BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6518 138.31C45.1203 101.565 81.2091 71.6946 114.286 93.727L114.331 93.7613C126.172 103.485 128.612 117.987 128.896 132.388C128.896 133.484 120.571 135.472 120.511 135.225C116.306 120.924 114.959 106.661 101.897 97.7717L101.832 97.7336C73.7166 84.2323 53.5626 119.008 54.5048 143.79C54.5068 143.861 54.526 143.93 54.5609 143.992C54.5957 144.053 54.6451 144.105 54.7046 144.142C54.7641 144.18 54.8319 144.202 54.902 144.207C54.9721 144.212 55.0423 144.2 55.1065 144.171C57.1174 143.323 59.2097 142.685 61.3502 142.267C61.4364 142.251 61.5155 142.208 61.5765 142.144C61.6375 142.081 61.6774 142 61.6908 141.913C63.1597 132.839 66.5331 124.184 71.5862 116.525C89.2579 90.7221 108.625 108.908 112.174 131.607L104.303 133.363C97.5904 108.988 72.763 110.351 69.8682 140.359",
    stroke: "#2C4A43",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_26_1261)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 67,
    r: 46,
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.843 102.009C161.26 102.009 177 86.4274 177 67.2062C177 47.9851 161.26 32.4033 141.843 32.4033C122.427 32.4033 106.687 47.9851 106.687 67.2062C106.687 86.4274 122.427 102.009 141.843 102.009Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.387 90.2869C156.8 90.2869 166.052 81.1281 166.052 69.8302C166.052 58.5323 156.8 49.3735 145.387 49.3735C133.975 49.3735 124.723 58.5323 124.723 69.8302C124.723 81.1281 133.975 90.2869 145.387 90.2869Z",
    fill: "#FFE768"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.917 83.5524C112.677 85.1755 107.099 83.7026 107.242 79.4172C107.424 73.835 115.531 71.4776 120.073 72.5725L120.94 69.468C115.895 68.6822 107.441 65.5605 108.795 59.0851C109.823 54.1427 115.405 54.4561 119.032 56.4399C119.343 56.6082 119.7 56.6723 120.051 56.6224C120.402 56.5726 120.727 56.4116 120.978 56.1635C121.228 55.9154 121.391 55.5937 121.441 55.2464C121.491 54.8991 121.427 54.545 121.257 54.2371C118.654 49.7284 116.186 43.9058 121.17 39.9767C123.799 37.907 126.635 37.4562 129.845 38.2591C132.682 38.9848 135.627 40.6638 135.211 43.9358H138.464C138.325 39.6418 141.622 34.4589 145.986 33.4241C151.59 32.0929 155.758 38.7401 154.154 43.6181C154.082 43.8919 154.083 44.1795 154.158 44.4525C154.233 44.7256 154.379 44.9744 154.581 45.1744C154.783 45.3745 155.034 45.5188 155.31 45.593C155.586 45.6672 155.877 45.6688 156.153 45.5975C162.183 43.618 169.418 43.1285 172.203 50.0376C174.554 55.8689 170.376 61.4983 164.581 62.808C162.846 63.1987 163.241 65.3844 164.581 65.9125C169.262 67.8362 175.668 75.2305 172.701 80.4821C170.281 84.7761 163.245 85.8625 159.641 82.5475C158.678 81.663 156.765 82.2254 156.865 83.6854C157.16 88.0438 162.005 91.96 159.537 96.5417C157.845 99.6892 153.273 101.51 149.868 100.574C146.151 99.5518 143.101 96.0737 143.839 92.1189C144.212 90.1093 141.175 89.2204 140.702 91.2601C140.03 94.1542 138.681 97.1514 135.931 98.6458C132.942 100.269 129.39 99.2297 126.74 97.4262C123.76 95.3952 122.324 91.8054 124.176 88.5376C126.089 85.1583 129.438 82.8652 132.556 80.6882C133.315 80.1643 133.78 78.8547 132.886 78.1634C127.559 74.0239 123.148 68.6736 124.645 61.4854C125.985 55.0701 131.862 51.6779 138.135 51.6092C143.708 51.549 149.72 53.3268 153.889 57.0926C158.747 61.4854 160.157 68.8539 157.333 74.7839C153.863 82.0837 144.35 83.2002 137.336 81.2894C135.315 80.7355 134.452 83.8658 136.469 84.394C144.008 86.4508 153.004 85.4073 158.296 79.181C163.328 73.2595 163.124 63.4692 158.535 57.3889C150.61 46.89 128.891 43.7426 122.532 57.5392C120.676 61.5713 120.706 66.3806 122.263 70.5028C123.842 74.7023 127.074 77.7383 130.561 80.4435L130.891 77.9143C126.987 80.6496 122.419 83.7542 120.641 88.3874C118.988 92.6814 120.931 97.1901 124.545 99.8309C128.041 102.407 132.808 103.648 136.903 101.759C140.742 99.9812 142.902 96.0565 143.813 92.1189L140.676 91.2601C139.809 95.8976 142.086 100.23 146.216 102.536C150.679 105.027 155.654 104.189 159.623 101.158C162.781 98.7446 163.913 95.2149 163.093 91.4018C162.687 89.783 162.105 88.2122 161.358 86.717C160.951 85.8238 160.126 84.3639 160.057 83.6812L157.281 84.8191C162.408 89.5425 171.951 88.2242 175.447 82.1052C179.624 74.8054 172.016 65.5303 165.384 62.7822V65.8867C172.879 64.1949 178.097 56.616 175.282 49.1401C173.903 45.4859 171.088 42.3599 167.18 41.4109C163.271 40.4619 158.999 41.2219 155.234 42.4629L157.233 44.4425C159.402 37.7825 153.924 29.3104 146.506 30.0446C140.065 30.6802 134.959 37.7181 135.155 43.9057C135.224 46.0527 138.152 45.911 138.408 43.9057C138.941 39.7019 135.606 36.8292 131.936 35.5152C128.136 34.1497 124.072 34.2528 120.606 36.374C116.932 38.6241 114.599 42.2397 114.967 46.5981C115.232 49.9345 116.772 52.9489 118.437 55.8087L120.663 53.6059C115.418 50.7332 107.624 50.9565 105.771 57.6509C103.381 66.2947 112.82 71.3917 120.086 72.5168C122.103 72.8302 123.031 69.9102 120.953 69.4121C114.178 67.7804 103.715 71.7223 104.006 79.838C104.24 86.4293 112.369 88.8897 117.574 86.279C119.444 85.3386 117.8 82.5604 115.934 83.4965L115.917 83.5524Z",
    fill: "#2C4A43"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_26_1261)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 246,
    r: 46,
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_1261)",
    filter: "url(#filter6_d_26_1261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2188 275.576C54.9978 277.779 61.3002 278.219 67.3292 276.84C73.3581 275.462 78.8428 272.326 83.0896 267.83C87.3364 263.334 90.1547 257.679 91.1879 251.582C92.2212 245.484 91.423 239.217 88.8945 233.573C86.3659 227.929 82.2204 223.161 76.9823 219.873C71.7442 216.585 65.6486 214.924 59.4665 215.1C53.2844 215.276 47.2934 217.282 42.251 220.863C37.2087 224.444 33.3415 229.44 31.1385 235.219C28.1844 242.968 28.4296 251.574 31.8203 259.142C35.2111 266.711 41.4695 272.622 49.2188 275.576V275.576Z",
    fill: "#EE8868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7754 279.377C64.7754 279.377 41.7044 268.506 39.1005 242.182C36.4966 215.858 55.6449 212.819 62.5442 220.212C66.7613 224.73 69.2383 235.863 66.7774 238.135C64.0201 240.68 60.1661 236.107 68.6141 231.408C76.556 226.998 91.8894 229.643 87.9563 244.817C81.9859 267.862 49.1384 272.699 38.0771 263.367",
    stroke: "#2C4A43",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_26_1261)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567,
    y: 133.065,
    width: 84.9098,
    height: 89.4417,
    rx: 8,
    transform: "rotate(-68.617 567 133.065)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.715 120.95C622.001 124.136 630.494 120.805 633.683 113.51C636.873 106.215 633.551 97.7191 626.265 94.5332C618.978 91.3473 610.485 94.6783 607.296 101.973C604.106 109.268 607.428 117.764 614.715 120.95Z",
    fill: "#FFE768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.614 134.916C597.182 127.573 602.54 121.539 609.509 118.141C616.479 114.743 624.488 114.258 631.778 116.795C639.068 119.333 645.039 124.684 648.379 131.672C651.719 138.66 652.154 146.713 649.588 154.058",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.937 116.622C616.437 117.251 616.903 118.813 617.352 120.253C617.723 121.441 619.314 121.234 619.807 120.3C620.7 118.611 621.988 116.196 624.271 116.443C626.554 116.69 626.251 119.311 625.973 120.963C625.769 122.183 627.597 123.133 628.321 121.99C629.582 119.989 631.324 117.219 634.114 117.862C636.904 118.505 635.557 121.56 634.66 123.247C634.051 124.394 635.671 125.703 636.665 124.855C638.397 123.371 640.649 121.714 643.053 122.506C644.022 122.821 645.03 123.506 645.147 124.583C645.313 126.158 643.4 127.304 642.29 128.039C641.243 128.743 641.908 130.761 643.226 130.435C645.261 129.93 648.553 129.027 650.009 131.147C651.751 133.674 647.674 135.408 645.939 136.113C644.451 136.721 645.137 138.671 646.579 138.673C649.214 138.664 650.921 141.792 649.142 143.852C647.152 146.157 643.65 145.037 641.941 143.027C641.108 142.047 639.389 142.574 639.546 143.967C639.813 146.407 635.255 147.702 633.476 147.896C631.446 148.116 626.541 146.525 628.531 143.627L626.28 142.256C625.413 143.813 622.784 144.642 621.256 143.544C620.413 142.935 619.98 141.643 619.751 140.679C619.561 139.876 619.224 138.125 619.992 137.474C620.761 136.822 621.693 137.307 621.262 138.223C620.859 139.092 619.72 139.097 618.793 139.269C617.107 139.584 615.384 139.65 613.679 139.465C611.97 139.315 610.374 138.549 609.187 137.311C607.701 135.763 606.866 133.117 608.679 131.447L606.865 129.535C604.323 131.978 600.425 130.111 599.152 127.324C597.848 124.469 598.956 121.43 601.71 119.997C603.386 119.126 605.724 118.654 607.556 119.285C607.918 119.404 608.42 119.565 608.475 119.961C608.523 120.277 607.904 120.931 607.794 120.961C606.973 121.175 606.029 119.097 605.776 118.375C604.985 116.143 605.061 113.632 605.617 111.335C607.292 104.373 613.582 99.4597 620.733 99.2327C627.773 99.0035 636.816 104.913 636.344 112.707C636.245 114.402 638.875 114.801 638.976 113.083C639.538 103.687 629.674 96.5203 620.967 96.5741C611.448 96.6366 603.027 104.254 602.583 113.85C602.448 116.672 602.948 119.907 604.875 122.101C606.311 123.735 608.597 124.204 610.125 122.39C611.865 120.293 611.155 117.768 608.634 116.828C605.771 115.759 602.179 116.5 599.667 118.112C595.73 120.651 594.929 125.694 597.371 129.558C599.885 133.538 605.475 134.519 608.94 131.185C610.016 130.149 608.235 128.252 607.127 129.273C602.997 133.075 605.601 138.957 610.043 141.182C612.111 142.221 614.652 142.291 616.917 142.154C618.635 142.046 621.226 141.889 622.641 140.785C625.421 138.62 624.027 134.42 620.455 134.62C616.36 134.863 616.532 139.93 617.673 142.752C618.508 144.833 619.942 146.285 622.241 146.573C623.528 146.754 624.84 146.539 626.002 145.956C627.164 145.374 628.123 144.452 628.75 143.312C629.477 142.012 627.347 140.709 626.499 141.941C623.582 146.196 628.029 150.42 632.31 150.581C636.073 150.723 642.751 148.349 642.224 143.635L639.829 144.574C642.868 148.153 649.015 149.292 651.793 144.725C654.286 140.634 650.698 136.021 646.316 136.018L646.957 138.579C650.05 137.318 654.302 134.801 652.866 130.742C651.392 126.613 646.407 126.938 642.949 127.769L643.884 130.169C645.621 128.992 647.542 127.509 647.843 125.317C648.093 123.524 647.132 121.908 645.727 120.875C642.207 118.31 638.058 120.175 635.129 122.689L637.133 124.297C638.671 121.399 639.514 117.206 635.757 115.564C631.602 113.778 628.344 117.062 626.298 120.292L628.646 121.318C629.146 118.334 628.771 114.608 625.2 113.868C621.365 113.074 618.988 116.228 617.412 119.214L619.867 119.261C619.197 117.106 618.216 115.074 616.043 114.162C614.466 113.504 613.394 115.939 614.977 116.6L614.937 116.622Z",
    fill: "#2C4A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.767 99.4282L586.315 103.265L603.72 105.303L604.171 101.466L586.767 99.4282Z",
    fill: "#EE8868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.304 95.3309L635.445 98.5435L650.027 88.8028L647.885 85.5903L633.304 95.3309Z",
    fill: "#EE8868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.747 88.9701L626.497 89.8853L630.662 72.8459L626.913 71.9308L622.747 88.9701Z",
    fill: "#EE8868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.772 93.2751L611.662 90.7114L600.042 77.5916L597.152 80.1553L608.772 93.2751Z",
    fill: "#EE8868"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_26_1261)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 463,
    cy: 594,
    r: 46,
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M448.285 627.292C465.02 635.416 485.172 628.434 493.296 611.698C501.419 594.963 494.437 574.811 477.702 566.688C460.966 558.564 440.814 565.546 432.691 582.281C424.568 599.017 431.549 619.169 448.285 627.292Z",
    fill: "#FFE768"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M444.59 580.336C444.901 579.216 445.429 578.168 446.145 577.252C446.861 576.336 447.75 575.57 448.762 574.998C449.774 574.426 450.889 574.059 452.043 573.917C453.197 573.776 454.367 573.864 455.488 574.175C457.75 574.804 459.67 576.305 460.825 578.35C461.98 580.394 462.276 582.813 461.648 585.076",
    fill: "#5DA7EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M479.659 605.434C478.036 609.55 474.846 612.852 470.788 614.616C466.731 616.379 462.139 616.459 458.023 614.838C453.906 613.216 450.603 610.025 448.839 605.967C447.074 601.91 446.994 597.317 448.616 593.2",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M472.525 589.746C473.249 588.841 474.143 588.088 475.158 587.529C476.173 586.97 477.288 586.616 478.439 586.488C479.59 586.36 480.756 586.459 481.869 586.782C482.981 587.104 484.02 587.642 484.925 588.366C486.752 589.827 487.924 591.954 488.184 594.28C488.443 596.605 487.769 598.938 486.308 600.766",
    fill: "#5DA7EB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M497.297 599.916C498.502 591.444 497.869 582.622 493.703 574.999C490.329 568.833 484.728 564.082 478.248 561.425C465.37 556.141 449.381 558.388 438.87 567.665C427.645 577.574 424.204 595.072 430.864 608.474C435.059 616.917 442.798 622.871 451.411 626.358C458.846 629.366 467.108 630.196 474.678 627.169C483.969 623.453 491.355 614.841 495.296 605.775C495.388 605.585 495.478 605.399 495.544 605.197C496.02 604.017 494.73 602.637 493.559 603.472C488.464 607.132 483.226 610.762 477.568 613.507C474.278 615.1 470.741 616.456 467.058 616.635C459.09 617.018 450.607 611.392 447.533 604.162C445.839 600.175 445.395 595.407 446.987 591.305L445.169 591.935L474.323 603.146L478.563 604.777C480.185 605.399 481.386 602.958 479.751 602.33L450.598 591.118L446.357 589.488C445.714 589.244 444.822 589.387 444.54 590.117C440.895 599.521 445.539 609.956 453.714 615.243C457.018 617.383 460.953 619.027 464.919 619.315C468.754 619.596 472.509 618.628 476.039 617.172C482.879 614.335 489.097 610.031 495.081 605.735L493.097 604.009C490.278 611.012 485.065 617.715 478.813 621.914C473.231 625.689 466.399 627.145 459.763 625.973C451.082 624.477 442.269 619.591 436.758 612.67C427.75 601.366 428.23 584.552 437.193 573.338C445.385 563.106 459.844 559.334 472.325 562.34C478.464 563.812 484.25 567.052 488.331 571.919C493.131 577.656 495.143 585.016 495.158 592.402C495.151 594.745 494.973 597.084 494.627 599.402C494.383 601.126 497.058 601.638 497.307 599.896L497.297 599.916Z",
    fill: "#2C4A43"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_1261",
    x: 574,
    y: 529,
    width: 78.6826,
    height: 80.4038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_26_1261",
    x: 516,
    y: 500,
    width: 103.204,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_26_1261",
    x: 693.715,
    y: 256.222,
    width: 184.569,
    height: 131.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_26_1261",
    x: 31.8082,
    y: 70.6027,
    width: 113.82,
    height: 89.3153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.794282
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.794282
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_26_1261",
    x: 93.4793,
    y: 20.2397,
    width: 95.0413,
    height: 95.0413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.760331
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.760331
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_26_1261",
    x: 12.4793,
    y: 199.24,
    width: 95.0413,
    height: 95.0413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.760331
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.760331
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_26_1261",
    x: 16,
    y: 204,
    width: 88.7148,
    height: 88.7148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_26_1261",
    x: 565,
    y: 53,
    width: 118.243,
    height: 115.675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_26_1261",
    x: 415.479,
    y: 547.24,
    width: 95.0413,
    height: 95.0413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.760331
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.760331
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_1261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_1261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_1261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.54,
    height: 62.54,
    fill: "white",
    transform: "translate(42.2771 206) rotate(20.8674)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordPlayerHappyHouse);
export default __webpack_public_path__ + "static/media/record-player-happy-house.02fc15e22a372d06214e79801aa46bde.svg";
export { ForwardRef as ReactComponent };